import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../../enum/constant";

const NewBkdata = ({ currency }) => {
  const [bankInfoList, setBankInfoList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBankInfo = async () => {
      try {
        let endpoint = "";
        if (currency === "USD") {
          endpoint = baseUrl + "api/adminbank-Usdcurrency";
        } else if (currency === "EUR") {
          endpoint = baseUrl + "api/adminbank-Eurocurrency";
        }

        const response = await fetch(endpoint);
        const data = await response.json();
        setBankInfoList(data);
        setLoading(false);
      } catch (err) {
        setError("Error fetching bank info.");
        setLoading(false);
      }
    };

    fetchBankInfo();
  }, [currency]);

  return (
    <div className="container mt-4">
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : bankInfoList.length > 0 ? (
        bankInfoList.map((info, index) => (
          <div key={index} className="bnk-detail mt-3">
            <h4>Bank {index + 1}</h4>
            <table className="table table-sm">
              <tbody>
                <tr>
                  <td><strong>Bank Name:</strong></td>
                  <td>{info.bank_name}</td>
                  <td><strong>BIC/Swift:</strong></td>
                  <td>{info.bic_swift}</td>
                </tr>
                <tr>
                  <td><strong>Reference Field:</strong></td>
                  <td>{info.reference_field}</td>
                  <td><strong>Supported Payments:</strong></td>
                  <td>{info.supported_payments}</td>
                </tr>
                <tr>
                  <td><strong>Bank Address:</strong></td>
                  <td>{info.bank_address}</td>
                  <td><strong>Company Name:</strong></td>
                  <td>{info.company_name}</td>
                </tr>
                <tr>
                  <td><strong>Company Address:</strong></td>
                  <td>{info.company_address}</td>
                  <td><strong>Account Number:</strong></td>
                  <td>{info.account_number}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ))
      ) : (
        <p className="text-center">No data available.</p>
      )}
    </div>
  );
};

export default NewBkdata;
